import { DataTable } from '../../../../design-system/data-table/data-table';
import { InvoiceEvidenceView } from '../../../../types/entity-types';
import {
  DATE_PAID_COLUMN_ID,
  INVOICE_INFO_COLUMN_ID,
  paidInvoiceTableColumnsDefinition,
} from './paid-invoice-table-columns-definition';
import { sortEvidencesByTxnFspDateNewestToOldest } from './utils/sort-evidences-by-txn-fspDate-newest-to-oldest';

type PaidInvoiceTableInvoiceTableProps = {
  evidences: InvoiceEvidenceView[];
  onSelectMenuItem: <MenuItemVariant>(payload: { entityId: string; menuItemVariant: MenuItemVariant }) => void;
  onReviewTransaction: (transactionId: string) => void;
  onDataSorted: (sortedEvidence: InvoiceEvidenceView[]) => void;
};

export const PaidInvoiceTable = ({
  evidences,
  onSelectMenuItem,
  onReviewTransaction,
  onDataSorted,
}: PaidInvoiceTableInvoiceTableProps) => {
  const sortedEvidences = sortEvidencesByTxnFspDateNewestToOldest(evidences);

  return (
    <DataTable
      columns={paidInvoiceTableColumnsDefinition}
      data={sortedEvidences}
      initialSorting={[
        { id: DATE_PAID_COLUMN_ID, desc: true },
        { id: INVOICE_INFO_COLUMN_ID, desc: false },
      ]}
      meta={{
        onSelectMenuItem,
        onReviewInvoice: onReviewTransaction,
      }}
      onDataSorted={onDataSorted}
    />
  );
};
